// extracted by mini-css-extract-plugin
export default {"card":"GestaoAcoesPermissao_card__znoBr","title":"GestaoAcoesPermissao_title__39sUr","actionsHeader":"GestaoAcoesPermissao_actionsHeader__kilQ4"};